import React, {useState} from 'react'
import PropTypes from 'prop-types'
import _ from "lodash"
import {Collapse} from 'reactstrap'

import DragWrapper from "./DragWrapper"
import InputContainer from "@src/components/helpers/InputContainer"

const Text = props => {
  const {data, provided} = props
  const [currentData, setCurrentData] = useState(data)

  return (
    <></>
  )
}

Text.propTypes = {}

export default Text